module.exports = __webpack_public_path__ + "images/ba1e50d4c4de28d8089ebb3ed0f4490d.png";